import { Avatar } from 'components/common'
import { AvatarProps } from 'components/common/Avatar/Avatar.types'
import {
  FileText,
  IconProps,
  Image,
  Paperclip,
  Video,
  File,
  PieChart,
  BarChart2,
} from 'react-feather'

import styles from './FileFormatIcon.module.scss'

type FileFormatIconType =
  | 'video'
  | 'image'
  | 'pdf'
  | 'text'
  | 'ppt'
  | 'xls'
  | 'doc'
  | 'other'

interface DocumentIconsProps {
  mimeType: string
  name?: string
  avatarProps?: Omit<AvatarProps, 'src' | 'content'>
}

const FileFormatIcon = ({
  mimeType,
  name,
  avatarProps,
}: DocumentIconsProps): JSX.Element => {
  const iconMap: Record<FileFormatIconType, IconProps> = {
    video: <Video />,
    image: <Image />,
    pdf: <Paperclip />,
    text: <FileText />,
    ppt: <PieChart />,
    doc: <FileText />,
    xls: <BarChart2 />,
    other: <File />,
  }

  const mimeToType = (mime: string) => {
    if (name?.endsWith('.ppt') || name?.endsWith('.pptx')) return 'ppt'
    if (name?.endsWith('.doc') || name?.endsWith('.docx')) return 'doc'
    if (name?.endsWith('.xls') || name?.endsWith('.xlsx')) return 'xls'

    if (mime.startsWith('image')) return 'image'
    if (mime.startsWith('video')) return 'video'
    if (mime.endsWith('pdf')) return 'pdf'
    if (mime.startsWith('text')) return 'text'
    return 'other'
  }

  return (
    <Avatar
      className={styles.icon}
      content={iconMap[mimeToType(mimeType)]}
      {...avatarProps}
    />
  )
}

export default FileFormatIcon
